import React from "react";

interface DigitCellsProps {
  n: number;
}

export default function DigitCells({ n }: DigitCellsProps) {
   const cells: React.ReactNode[] = [];
  for (let i = 0; i < n; i++) {
    cells.push(
      <span
        key={i}
        style={{
          border: "1px solid #000",
          borderLeft: i === 0 ? "1px solid #000" : "none",
          width: 13,
          height: 20,
          display: "inline-block",
        }}
      />
    );
  }
  return <span style={{ display: "inline-flex" }}>{cells}</span>;
}